import { errorNotification, successNotification } from './helpers/toastify.js';

import { generateMessAppointmentCourse } from './helpers/helpers';

// Відправка форми
const handleSubmit = async e => {
  e.preventDefault();

  const formData = {
    name: e.target.name.value,
    phone: e.target.phone.value,
    education: e.target.education.value,
  };

  try {
    await fetch('tel.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({
        text: generateMessAppointmentCourse(formData),
      }),
    }).then(successNotification);

    e.target.reset();
  } catch (error) {
    errorNotification();
  }
};

//Подія відправки форми
document
  .getElementById('appointment-course-form')
  .addEventListener('submit', handleSubmit);
